module.exports = __webpack_public_path__ + "img/thumbblacksheep3.2b18386e.png";